import { useEffect, useState } from 'react';

import { Router } from '@reach/router';
import { useDispatch } from 'react-redux';

import InfoBar from './components/InfoBar/InfoBar';
import LoadingBar from './components/LoadingBar/LoadingBar';
import {
  franchises,
  infoBarTexts,
  setAll,
} from './provider/models/franchisesModel';
import { fetchConsents } from './provider/models/reservationModel';
import { downloadedData } from './store/actions';
import { serviceTypes } from './store/initData/services';
import AgePageWrapper from './store/routeWrappers/AgePageWrapper';
import CityPageWrapper from './store/routeWrappers/CityPageWrapper';
import FormPageSingleWrapper from './store/routeWrappers/FormPageSingleWrapper';
import FormPageWrapper from './store/routeWrappers/FormPageWrapper';
import MapPageWrapper from './store/routeWrappers/MapPageWrapper';
import ServicePageWrapper from './store/routeWrappers/ServicePageWrapper';
import ThankYouPageWrapper from './store/routeWrappers/ThankYouPageWrapper';
import WorkshopFormRedirector from './store/routeWrappers/WorkshopFormRedirector';
import { env } from './utils/env';

export default function App() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const franchisesApiCall = async () => {
      await setAll();
      dispatch(downloadedData(franchises, 'franchises'));

      const consents = await fetchConsents();
      dispatch(downloadedData(consents, 'consents'));

      setLoading(false);
    };

    franchisesApiCall();
  }, [dispatch]);

  const Birthday = () =>
    (window.location.href = 'https://b24-nhof01.bitrix24.site/urodzinkiG4R/');

  const workshopService = serviceTypes.workshop;

  let content = <LoadingBar wholePage />;
  if (!loading) {
    content = (
      <Router
        style={{ position: 'relative', flexGrow: 1 }}
        basepath={`/${env.PUBLIC_URL}`}
      >
        {/* GLOBAL */}
        <ServicePageWrapper path="/" />
        <CityPageWrapper path="/:serviceId" />
        <WorkshopFormRedirector path="/przekieruj/:slug" />
        <ThankYouPageWrapper path="/thanks" />

        {/* WORKSHOP */}
        <AgePageWrapper
          path={`/${workshopService}/:cityId/:ageId`}
          serviceId={workshopService}
        />
        <MapPageWrapper
          path={`/${workshopService}/:cityId/:ageId/:robotId/*`}
          serviceId={workshopService}
        />
        <FormPageWrapper
          path={`/${workshopService}/:cityId/:ageId/:robotId/:locationId/:occurrenceId/formularz`}
          serviceId={workshopService}
        />
        {/* Signup for single location */}
        <FormPageSingleWrapper
          path={`/${workshopService}/:cityId/:ageId/:robotId/:locationId/:occurrenceId/formularzMiasto`}
          serviceId={workshopService}
        />
        <FormPageWrapper
          addressInput
          path={`/${workshopService}/:cityId/:ageId/:robotId/zaproponuj`}
          serviceId={workshopService}
        />

        {/* SUMMERPLAY and ACADEMY */}
        <MapPageWrapper path={`/:serviceId/:cityId/*`} hideSuggestButton />
        <FormPageWrapper
          path={`/:serviceId/:cityId/:locationId/:occurrenceId/formularz`}
        />
        <Birthday path="urodziny" />
      </Router>
    );
  }

  return (
    <div
      style={{
        height: '100%',
        display: 'flex',
        flexFlow: 'column',
        position: 'relative',
      }}
    >
      <InfoBar texts={infoBarTexts} />
      {content}
    </div>
  );
}
